import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Upload extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "fileName", Model.attribute('fileName'));
    _defineProperty(this, "mimeType", Model.attribute('mimeType'));
    _defineProperty(this, "size", Model.attribute('size'));
    /** Só em imagens, para reservar o espaço e evitar reflow ao carregar. */
    _defineProperty(this, "width", Model.attribute('width'));
    _defineProperty(this, "height", Model.attribute('height'));
    _defineProperty(this, "messageId", Model.attribute('messageId'));
    _defineProperty(this, "url", Model.attribute('url'));
    _defineProperty(this, "isImage", Model.attribute('isImage'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
  /** Pendente: anexado no composer, mensagem ainda não enviada. */
  isPending() {
    return this.messageId() === null;
  }
  humanSize() {
    var _this$size;
    const bytes = (_this$size = this.size()) != null ? _this$size : 0;
    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
      value /= 1024;
      unit++;
    }
    return (unit === 0 ? value : value.toFixed(1)) + ' ' + units[unit];
  }
  apiEndpoint() {
    return '/chat-uploads' + (this.exists ? '/' + this.id() : '');
  }
}
flarum.reg.add('ramon-chat', 'common/models/Upload', Upload);